<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4 text-center" is-centered>
        <template #leftAction>
          <FreeBackButton class="opacity-50" @click="hide" />
        </template>
        <h1 class="text-text-neutral-primary font-medium">
          {{ t('ancillaries.medicalInsurance.details.conditionsTitle') }}
        </h1>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="text-text-neutral-primary space-y-4 px-4 pb-4">
        <i18n-t
          tag="p"
          keypath="ancillaries.medicalInsurance.details.conditionsContent"
        >
          <template #link>
            <button
              class="font-medium text-green-500"
              type="button"
              @click="
                openInsuranceDocument(
                  appConfig.isDevRuntimeEnv,
                  medicalInsuranceConfig.RULES_FILE_LINK,
                )
              "
            >
              {{ t('ancillaries.medicalInsurance.details.here') }}
            </button>
          </template>
        </i18n-t>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeBackButton,
  } from 'freedom-shared';
  import { openInsuranceDocument } from 'shared';

  import { appConfig } from '@/shared/config';

  import { medicalInsuranceConfig } from '../config';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();
</script>
